var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHourglass(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8339 0.597156V1.19431H2.64907H3.46424V3.23691V5.27953L4.82437 6.63975L6.18452 8L4.82437 9.36025L3.46424 10.7205V12.7629V14.8053L2.65381 14.8102L1.84338 14.8152L1.83838 15.4076L1.83337 16H8.50689H15.1804L15.1754 15.4076L15.1704 14.8152L14.36 14.8102L13.5495 14.8053V12.7629V10.7205L12.1894 9.36025L10.8293 8L12.1894 6.63975L13.5495 5.27953V3.23691V1.19431H14.3647H15.1799V0.597156V0H8.50689H1.8339V0.597156ZM4.65855 2.99058V4.78682L5.9714 6.09958L7.28424 7.41232H8.50699H9.72973L11.0425 6.09947L12.3552 4.78663V2.99046V1.19431H8.50689H4.65855V2.99058ZM5.97129 9.90053L4.65855 11.2134V13.0095V14.8057H8.50689H12.3552V13.0094V11.2132L11.0424 9.90042L9.72954 8.58768H8.5068H7.28405L5.97129 9.90053Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHourglass);
export default __webpack_public_path__ + "static/media/icon--hourglass.3f7dba74f63537957dd229783bf044c9.svg";
export { ForwardRef as ReactComponent };